module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-917-retro.c67aad9e.jpg";